import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import NextWrapper from '@/components/layouts/Containers/NextWrapper/NextWrapper';
import { Adverts } from '@/reactPages/Adverts';

import { staticLinks } from '@/config/routingLinks';

const Page = () => {
  const router = useRouter();
  const [searchParams, setSearchParams] = useState(new URLSearchParams(`?${router.asPath.split('?')[1]}`));
  const [metaTitle, setMetaTitle] = useState('Аренда квартир на Сахалине');

  useEffect(() => {
    setSearchParams(new URLSearchParams(`?${router.asPath.split('?')[1]}`));

  }, [router.query, router.asPath]);

  useEffect(() => {
    if (router.asPath.split('?')[0] === staticLinks.adverts || router.asPath.split('?')[0] === staticLinks.mapAdverts) {
      if (searchParams.get('property_type') === 'Бизнес') {
        searchParams.get('deal_type') === 'Аренда'
          ? setMetaTitle('Снять коммерческую недвижимость на Сахалине')
          : setMetaTitle('Купить коммерческую недвижимость на Сахалине');
      } else {
        searchParams.get('deal_type') === 'Аренда'
          ? setMetaTitle('Аренда квартир на Сахалине')
          : setMetaTitle('Продажа квартир на Сахалине');
      }
    } else {
      searchParams.get('deal_type') === 'Аренда'
        ? setMetaTitle('Аренда квартир на площадках')
        : setMetaTitle('Продажа квартир на площадках');
    }
  }, [searchParams,router.asPath]);

  const meta = {
    title: metaTitle,
    description: 'Недвижимость в Сахалинской области. Купите уже сегодня.',
    keywords: 'Сахалинское ипотечное агентство, аренда, покупка, купить, арендовать',
  };

  return (
    <>
      <NextWrapper meta={meta}></NextWrapper>
      <Adverts></Adverts>
    </>
  );
};

export default Page;
